import React from "react";
import { Chat } from "@mui/icons-material";
import { ListItemIcon, MenuItem } from "@mui/material";

import { trackPageMenuItemClick } from "../helper";

interface IProps {
  handleClose: () => void;
}

const Support: React.FC<IProps> = ({ handleClose }: IProps) => {
  const handleClick = () => {
    handleClose();
    trackPageMenuItemClick("help", "support");
  };

  return (
    <MenuItem
      data-testid="support-button"
      component="a"
      href="mailto:fondhelp@biarrinetworks.com"
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      <ListItemIcon>
        <Chat />
      </ListItemIcon>
      Support Team
    </MenuItem>
  );
};

export default Support;
